import { render } from "./SpeakersView.vue?vue&type=template&id=597b6e5e&scoped=true"
import script from "./SpeakersView.vue?vue&type=script&lang=js"
export * from "./SpeakersView.vue?vue&type=script&lang=js"

import "./SpeakersView.vue?vue&type=style&index=0&id=597b6e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597b6e5e"]])

export default __exports__